import React from 'react'
import PropTypes from 'prop-types'

import { colors, media } from '../../constants/style'

import image from '../../../static/assets/images/biglietteria.jpg'

import { Row } from '../UI/Grid'

const Wrapper = Row.extend`
  background-color: ${colors.gray};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
  height: 320px;
  margin-bottom: 14px;
  padding: 40px 20px;
  position: relative;
  ${media.medium`
    background-position: 100% 35%;
    background-repeat: no-repeat;
    background-size: 110% auto;
  `}
  p, strong {
    font-size: 1.5rem;
    line-height: 2rem;
    text-transform: uppercase;
    ${media.medium`
      font-size: 3rem;
      line-height: 3.5rem;
    `}
  }
  p {
    font-weight: normal;
  }
  > * {
    z-index: 1;
  }
  &:before {
    background-color: ${colors.red};
    content: '';
    height: 100%;
    left: 0;
    mix-blend-mode: overlay;
    opacity: .5;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }
  &:after {
    background-color: ${colors.red};
    bottom: -14px;
    content: '';
    height: 7px;
    left: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;
  }

  ${({ image }) => {
    if (image) {
      return `background-image: url('${image }');`
    }
  }}

`

const Banner = ({ children }) => (
  <Wrapper image={image} shrink={1}>
    {children}
  </Wrapper>
)

Banner.propTypes = {
  children: PropTypes.element.isRequired,
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner/index.js